import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task03 } from "../../../../../task/course-04/lesson-02/task-03";

const task: Slide = {
  title: `Give the value of U (in Volts).`,
  description: "Fill in the value.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [4, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/02/task/task-3-item-1.svg`,
                },
              },
              styles: {
                padding: "5%",
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task03.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
